import Sellpoints from '@/pages/Sellpoints'

export default {
  path: '/sellpoints',
  name: 'Sellpoints',
  component: Sellpoints
}



// WEBPACK FOOTER //
// ./src/router/sellpoints.js